import Smartphones from 'Todo/views/TodoErrorEventsView/containers/Smartphones'
import Tablets from 'Todo/views/TodoErrorEventsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TodoErrorEventsView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoErrorEventsView
